import { IkeToken } from '@ikegps/core-api';
import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { AppStore } from '../../store';
import { CollectionFormMigrateModal } from '../collection.form.migrate.modal/collection.form.migrate.modal';
import { readPoleForm } from '@ikegps/core-shared';

export const CollectionFormMigrateCtrl = {
	canDisplay(): boolean {
		// Ensure all collections have the same form revision
		const forms = Array.from(new Set(CurrentState.Tag.collections.map((c) => c.formRevision)));
		if (forms.length !== 1) {
			return false;
		}

		// Ensure the department has the correct token
		const hasToken = Services.Token.has(IkeToken.FEATURE_COLLECTION_FORM_MIGRATE);
		if (!hasToken) {
			return false;
		}

		// Ensure the user is of the correct type
		const isAdminType =
			Services.UserProfile.isDepartmentAdmin(Services.UserProfile.get(Services.User.current.objectId)) ||
			Services.UserProfile.isDepartmentDataAdmin(Services.UserProfile.get(Services.User.current.objectId));
		if (!isAdminType) {
			return false;
		}

		// Ensure that the form of the selected collections is a PLA/Base form or a PLS form
		const sourceForm = AppStore.Form.get(forms[0]!);
		return Boolean(sourceForm && (readPoleForm(sourceForm) || sourceForm.metadata.isPLSCADDForm()));
	},

	showMigrateFormModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionFormMigrateModal(
			{
				title: T.COLLECTION_MIGRATE_FORM_TITLE,
				confirm: T.COLLECTION_MIGRATE_FORM,
				success: {
					key: T.COLLECTION_MIGRATE_FORM_SUCCESS,
				},
			},
			collections
		);

		modal.open();
	},
};
